<template>
  <div class="tile">
    <div class="tile__container">
      <ul class="tile__container__list">
        <li
          v-for="(value, key) in filteredSummary"
          :key="key"
          class="tile__container__list__item"
        >
          <span>{{ key }}</span>
          <span>
            <template v-if="key !== 'DIFFICULTY'">
              {{ value }}
            </template>
            <template v-else>
              <Difficulty :difficulty="value" alwaysVisible colored />
            </template>
          </span>
        </li>
        <li v-if="skillCheckLabsCount" class="tile__container__list__item">
          <span><SkillCheckTile /></span>
          <span>{{ skillCheckLabel }}</span>
        </li>
      </ul>
      <div
        v-if="certificationVisibility"
        class="tile__container__certification-pill"
        :style="`background: ${learningAreaColor}`"
      >
        <CertificateIcon />
        <span>
          {{ certificateName }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Difficulty from '@/components/properties/Difficulty.vue'
import CertificateIcon from '@/assets/icons/search/certificate.svg'
import SkillCheckTile from '@/assets/icons/skillcheck/skill_check_tile.svg'

export default {
  name: 'SummaryTile',
  components: {
    Difficulty,
    CertificateIcon,
    SkillCheckTile,
  },
  props: {
    learningAreaColor: {
      type: String,
      required: true,
    },
    summary: {
      type: Object,
      required: true,
    },
    certificate: {
      type: Object,
      required: false,
      default: null,
    },
    skillCheckLabsCount: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState({ isAuthenticated: state => state.auth.isAuthenticated }),
    certificateName() {
      return this.certificate?.name
    },
    certificationVisibility() {
      return !!this.certificateName
    },
    filteredSummary() {
      return Object.fromEntries(
        Object.entries(this.summary).filter(
          ([_, value]) => value !== null && value !== undefined
        )
      )
    },
    skillCheckLabel() {
      const plural = this.skillCheckLabsCount > 1 ? 's' : ''
      return `${this.skillCheckLabsCount} lab${plural}`
    },
  },
}
</script>
<style lang="scss" scoped>
.tile {
  display: flex;
  padding: 20px;
  background: var(--glass-dark);
  backdrop-filter: blur(22px);
  font-size: rem(12px);
  line-height: rem(14px);
  max-width: none;
  width: 100%;
  height: auto;
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    gap: 30px;
    width: 100%;
    &__list {
      width: 100%;
      margin: 0;
      padding: 0;

      &__item {
        border-block-end: 1px solid var(--tundora-gray);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
        color: var(--mid-gray);

        &:first-child {
          padding-top: 0;
          padding-bottom: 6px;
        }
        &:last-child {
          padding-bottom: 0;
          border-block-end: none;
        }
      }
    }
    &__certification-pill {
      display: flex;
      width: fit-content;
      justify-content: center;
      align-items: center;
      padding: 8px 14px;
      gap: 10px;
      border-radius: 100px;
      color: var(--charcoal);
    }
  }
}
</style>
